import styled from 'styled-components';

export const Label = styled.div`
  margin-left: 51px;
  ${({ theme }) => theme.fonts.FoundersGrotesk};
  color: ${({ theme }) => theme.colors.KBNight};
  font-size: 14px;
`;

export const Text = styled.div`
  margin-left: 51px;
  ${({ theme }) => theme.fonts.DomaineDisplay};
  color: ${({ theme }) => theme.colors.KBNight};
  font-size: 18px;
  font-weight: 400;
  text-decoration: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    font-size: 24px;
  }
`;
